// Giải pháp tùy chỉnh cho Discount Code trong Cart Drawer
// Dựa trên cấu trúc HTML chính xác của theme
(function () {
  // Function để redirect đến checkout với discount code
  function redirectToCheckoutWithDiscount(code) {
    // Tạo form động để submit
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart';
    form.style.display = 'none';

    // Thêm field checkout
    const checkoutField = document.createElement('input');
    checkoutField.type = 'hidden';
    checkoutField.name = 'checkout';
    form.appendChild(checkoutField);

    // Thêm field discount code
    const discountField = document.createElement('input');
    discountField.type = 'hidden';
    discountField.name = 'discount';
    discountField.value = code;
    form.appendChild(discountField);

    document.body.appendChild(form);
    form.submit();
  }

  // Function để thiết lập sự kiện cho discount code
  // Chạy khi các phần tử xuất hiện (cart drawer mở) - không retry vô hạn
  function setupCartDiscountLogic() {
    const discountInput = document.querySelector('.field__input[placeholder="Enter your discount code"]');
    const applyButton = document.querySelector('button[data-text="Apply"]');
    const checkoutButton = document.querySelector('button.cart__checkout-button');

    // Chưa có form discount trên trang (VD: trang product) - thoát,
    // MutationObserver sẽ gọi lại khi cart drawer render
    if (!discountInput || !checkoutButton) return;

    // Xử lý sự kiện khi nhập discount code (chỉ gắn 1 lần)
    if (!discountInput.hasAttribute('data-discount-handler')) {
      discountInput.setAttribute('data-discount-handler', 'true');
      discountInput.addEventListener('input', function () {
        const code = this.value.trim();
        if (code) {
          localStorage.setItem('shopify_discount_code', code);
        }
      });
    }

    // Xử lý nút Apply (chỉ gắn 1 lần)
    if (applyButton && !applyButton.hasAttribute('data-discount-handler')) {
      applyButton.setAttribute('data-discount-handler', 'true');
      applyButton.addEventListener('click', function (e) {
        const code = discountInput.value.trim();
        if (code) {
          localStorage.setItem('shopify_discount_code', code);
          e.preventDefault();
          e.stopPropagation();
          setTimeout(function () {
            redirectToCheckoutWithDiscount(code);
          }, 100);
          return false;
        }
      });
    }

    // Xử lý nút Checkout (chỉ gắn 1 lần)
    if (!checkoutButton.hasAttribute('data-discount-handler')) {
      checkoutButton.setAttribute('data-discount-handler', 'true');
      checkoutButton.addEventListener('click', function (e) {
        const code = discountInput.value.trim() || localStorage.getItem('shopify_discount_code');
        if (code) {
          e.preventDefault();
          e.stopPropagation();
          redirectToCheckoutWithDiscount(code);
          return false;
        }
      });
    }
  }

  // Debounce để tránh chạy setup liên tục khi DOM thay đổi nhiều
  let setupScheduled = false;
  function scheduleSetup() {
    if (setupScheduled) return;
    setupScheduled = true;
    setTimeout(function () {
      setupScheduled = false;
      setupCartDiscountLogic();
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Thiết lập logic khi trang tải (trang cart có sẵn form)
    setupCartDiscountLogic();

    // Theo dõi DOM để phát hiện cart drawer được render/mở
    const bodyObserver = new MutationObserver(scheduleSetup);
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  });
})();
